import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueGtag from 'vue-gtag';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import PollingPlugin from './plugins/polling';

Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();

Vue.use(VueClipboard);
Vue.use(PollingPlugin);

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GA },
  },
  router,
);

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

// Debug: Make store accessible in console
if (process.env.NODE_ENV !== 'production') {
  window.$store = store;
  window.$app = app;
  console.log('[Main] App mounted. GHL Polling initial state:', store.state.ghlPolling);
  console.log('[Main] Access store via window.$store in console');
}
